import React, { useState } from "react";
import Intro from "./components/Intro";
import GitHubActivity from "./components/GitHubActivity";
import About from "./components/About";
import TechStack from "./components/TechStack";
import Experience from "./components/Experience";
import Certifications from "./components/Certifications";
import Credits from "./components/Credits";
import NavBar from "./components/NavBar";
import SideNavBar from "./components/SideNavBar";
import Testimonials from "./components/Testimonials";
import FeaturedProjects from "./components/FeaturedProjects";
import Contact from "./components/Contact";
import Chatbot from "./components/Chatbot";
import { StarsCanvas } from "./components/StarBackground";
import "./App.css";
import "./styles/Global.css";

function App() {
  const [showStars, setShowStars] = useState(true);
  return (
    <div className="App">
      {showStars && <StarsCanvas />}
      <NavBar showStars={showStars} setShowStars={setShowStars} />
      <SideNavBar showStars={showStars} setShowStars={setShowStars} />
      
      <div id="content">
        <Intro />
        <GitHubActivity />
        <About />
        <Testimonials />
        <FeaturedProjects />
        <Experience />
        <Certifications />
        <TechStack />
        <Contact />
        <Credits />
      </div>
      <Chatbot />
    </div>
  );
}

export default App;